import styled from 'styled-components'

export const MiningItem = styled.div`
  width: 100%;
  margin: 0.2rem auto;
  position: relative;
  text-align: start;

  input {
    background: #fff;
  }

  .errorContent {
    input {
      border: 1px solid red;
    }
  }
  .start {
    &:before {
      content: '*';
      color: red;
      margin-right: 6px;
    }
  }
`
